<template>
  <div class="cart-container">
    <div
      v-if="count >= 1"
      class="cart"
    >
      <p class="cart__heading">
        {{ count == 1 ? $modeoL10n.one_product_in_total : $modeoL10n.x_products_in_total | formatString(count) }}
      </p>

      <div class="cart__items-heading">
        <span class="cart__column cart__column--heading cart__column--heading--product cart__column--product">
          {{ $modeoL10n.product }}
        </span>
        <span class="cart__column cart__column--heading cart__column--availability">
          {{ $modeoL10n.availability }}
        </span>
        <span class="cart__column cart__column--heading cart__column--price">
          {{ $modeoL10n.price }}
        </span>
        <span class="cart__column cart__column--heading cart__column--amount">
          {{ $modeoL10n.amount }}
        </span>
        <span class="cart__column cart__column--heading cart__column--sum">
          {{ $modeoL10n.total }}
        </span>
      </div>

      <div
        class="cart__items"
        role="list"
      >
        <template v-for="cartItem in cartContents">
          <CartItem
            :key="cartItem.key"
            :original-cart-item="cartItem"
            order-type="order"
            @remove="removeItem(cartItem)"
            @update="updateCartItem(cartItem, $event)"
          />
        </template>
      </div>
    </div>
    <div
      v-if="count == 0"
      class="cart__empty-container empty-cart"
    >
      <p class="empty-cart__text">
        {{ $modeoL10n.no_products }}
      </p>
    </div>
    <div class="cart-footer">
      <a
        class="cart-footer__button btn btn--small btn--secondary"
        target="_blank"
        :href="($store.getters.showPricesWithVat) ? '?format=pdf&show_prices=true&vat=true' : '?format=pdf&show_prices=true&vat=false' "
      >{{ $modeoL10n.download_details_as_pdf }}</a>
      <a
        class="cart-footer__button btn btn--small btn--secondary"
        target="_blank"
        href="?format=pdf"
      >{{ $modeoL10n.download_details_as_pdf_without_prices }}</a>
    </div>
    <CheckoutCoupons :nonce="nonce" />
  </div>
</template>

<script>
import CartItem from '../../components/cart/cart-item.vue';
import CheckoutCoupons from '../../components/checkout/checkout-coupons.vue';
import { EventBus } from '../../event-bus.js';
import axios from 'axios';
import _ from 'lodash';

export default {
    components: {
        CartItem,
        CheckoutCoupons,
    },
    props: {
        defaultCartContents: {
            type: Array,
            default: function() {
                return [];
            },
        },
        nonce: {
            type: String,
            default: '',
        },
    },

    data : function () {
        return {
            cartContents: [],
            count: 0,
        }
    },

    mounted: function() {
        this.cartContents = this.defaultCartContents;
        this.updateCartCount();
        this.$store.commit('setCartContents', this.cartContents);
        this.updateCartLongestDeliveryTime();
    },

    methods: {

        updateCartItem(cartItem, data) {
            const index = this.findCartItemIndexByKey(cartItem.key);
            this.cartContents[index].quantity = data.quantity;
            this.cartContents[index].estimated_delivery_time_with_add_ons = data.estimated_delivery_time_with_add_ons;
            this.updateCartCount();
            this.updateCartLongestDeliveryTime();
            this.$store.commit('setCartContents', this.cartContents);
        },

        updateCartLongestDeliveryTime() {
            let longestDeliveryTime = 0;
            this.cartContents.filter( cartItem => {
                if (cartItem.estimated_delivery_time_with_add_ons > longestDeliveryTime) {
                    longestDeliveryTime = cartItem.estimated_delivery_time_with_add_ons;
                }
            });
            this.$store.commit('setCartDeliveryTime', longestDeliveryTime);
        },

        updateCartCount() {
            let count = 0;
            this.cartContents.forEach( cartItem => {
                count += cartItem.quantity;
            });
            this.count = count;
        },

        findCartItemIndexByKey(key) {
            for (let i=0; i < this.cartContents.length; i++) {
                if (this.cartContents[i].key == key) {
                    return i;
                }
            }
        },

        removeItem(cartItem) {

            let request = {
                "cart_item_key": cartItem.key,
                "add_ons": cartItem.add_ons,
                "variation_id": cartItem.variation_id,
                "product_id": cartItem.product_id,
                "quantity": 0,
            };

            let config = {
                headers: {
                    'X-WP-Nonce': cartItem.nonce,
                },
            }

            axios.post('/wp-json/modeo/v2/cart/update_cart_item', request, config)
            .then(response => {

                const totals = {
                    subtotal: response.data.subtotal,
                    subtotalTax: response.data.subtotal_tax,
                    total: response.data.total,
                    discount: response.data.discount_total,
                    discountTax: response.data.discount_tax,
                    count: response.data.cart_product_count,
                };

                this.$store.commit('setTotals', totals);

                let newCartContents = _.clone(this.cartContents);

                _.remove(newCartContents, function(item) {
                    return item.key == cartItem.key;
                });
                this.cartContents = newCartContents;
                this.updateCartCount();
                this.updateCartLongestDeliveryTime();
                this.$store.commit('setCartContents', this.cartContents);
            })
            .catch((error) => {
                if ( error.response ) {

                    if ( error.response.status === 403 && error.response.data.code === 'Forbidden' ) {
                        let productAddedToCartData = {
                            message: this.$modeoL10n.offer_modification_failed,
                            notificationType: 'single-message',
                        };
                        EventBus.$emit( 'notify', productAddedToCartData );
                    }

                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log( error.response.data );
                    console.log( error.response.status );
                    console.log( error.response.headers );
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log( 'Error', error.message );
                }
                console.log( error.config );
            });

        },
    },
}
</script>
